import React from 'react';


import "react-datepicker/dist/react-datepicker.css";
import { MdDelete } from "react-icons/md";
import { MdFileDownload } from "react-icons/md";
import { FaAngleLeft } from "react-icons/fa6";
import { FaAnglesLeft } from "react-icons/fa6";
import { FaAngleRight } from "react-icons/fa6";
import { FaAnglesRight } from "react-icons/fa6";
import { HiOutlineChevronDown } from "react-icons/hi";
import { HiOutlineChevronUp } from "react-icons/hi";

import { useState } from 'react';
import { useEffect } from 'react';



import 'react-photo-view/dist/react-photo-view.css';

const ImageViewer = ({ imageArray, data }) => {
    const [idcard, setIdcard] = useState(null);
    const [filecounter, setfilecounter] = useState(0);
    const [showimage , setShowImage] = useState(false)

    const _normalizeUrl = (url) => {
        // Only replace spaces with %20, don't over-encode the URL
        if (url !== undefined)
            return url.replace(/ /g, '%20');
        else
            return null
    }
    useEffect(() => {
        //console.log("ImageViewer useEffect", imageArray);
        setShowImage(false)
        setIdcard(null);
        setfilecounter(0);
        if (imageArray.length > 0) {
            setIdcard(_normalizeUrl(imageArray[filecounter]));

        }
    }, [imageArray]);

    useEffect(() => {

        if (imageArray.length > 0) {
            setIdcard(_normalizeUrl(imageArray[filecounter]));
        }
    }, [filecounter]);

    const handlefirstcontract = () => {
        setfilecounter(pre => {
            return 0;
        });
    }

    const handlelastcontract = () => {
        setfilecounter(pre => {
            return imageArray.length - 1;
        });
    }
    const handlenextcontract = () => {
        setfilecounter(pre => {
            if (pre + 1 >= imageArray.length) {
                return 0;
            }
            return pre + 1;
        });
    }
    const handleprevcontract = () => {
        setfilecounter(pre => {
            if (pre - 1 < 0) {
                return imageArray.length - 1;
            }
            return pre - 1;
        });
    }

    const CloseForm = () => {
        setShowImage(false)
    }

    const OpenForm = () => {
        setShowImage(true)
    }
    const openfile = () => {
        window.open(idcard, '_blank');
    }


    return (
        <div id="preview" className='doublegrid' style={{ visibility: "visible" }} >
            <HiOutlineChevronDown onClick={OpenForm} id='closeformchevronDown' style={showimage === true? {display:"none"}:{display:"grid"}} />
            <HiOutlineChevronUp onClick={CloseForm} id='closeformchevronUp' style={showimage === true? {display:"grid"}:{display:"none"}}/>
            <div id={"imageviewer" + data.id} style={showimage === true? {display:"grid"}:{display:"none"}} >

                <img
                    id="imagedisplay"
                    src={idcard}
                    alt="Image Preview"
                    style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "contain",
                        border: "1px solid #ccc", // optional: nice border
                        display: "block", // no inline weirdness
                    }}
                    onClick={openfile}
                />
                <center>
                    <div className='navbuttons'>
                        <FaAnglesLeft id="first_img" onClick={handlefirstcontract} className="deletefile" visibility={imageArray.length > 1 ? "visible" : "hidden"}></FaAnglesLeft >
                        <FaAngleLeft id="prev_img" onClick={handleprevcontract} className="deletefile" visibility={imageArray.length > 1 ? "visible" : "hidden"}></FaAngleLeft>
                        <MdFileDownload id="open_img" onClick={openfile} className="deletefile" ></MdFileDownload>
                        <FaAngleRight id="next_img" onClick={handlenextcontract} className="deletefile" visibility={imageArray.length > 1 ? "visible" : "hidden"}></FaAngleRight>
                        <FaAnglesRight id="last_img" onClick={handlelastcontract} className="deletefile" visibility={imageArray.length > 1 ? "visible" : "hidden"}></FaAnglesRight>
                    </div>
                </center>
            </div>
        </div>

    )
}




export default ImageViewer;